export default "__VITE_ASSET__C6zkFXc3__"